var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 190.86 66.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 138.66,
    y1: 50.27,
    x2: 138.66,
    y2: 15.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4e3883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#5a448d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#6f589e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#7b64a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#8069ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#6b549b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5a448d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#513b85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4e3883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#513b86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#5d468f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#70599f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#8069ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7c65aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#725ca2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#624b93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e3883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 33.48,
    x2: 190.86,
    y2: 33.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#178b91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#1c8992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#3b7f9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#5477a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#6770a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#756caa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#7d69ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8069ad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 3.27,
    y1: 22.66,
    x2: 91.26,
    y2: 45.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#178b91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#109fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0bb0b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#07bcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#05c3c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#05c5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 58.1,
    y1: 6.93,
    x2: 87.99,
    y2: 25.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#9f84ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#8279c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#6d72ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#616d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#5d6c98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 173.79,
    y1: 46.79,
    x2: 160.56,
    y2: 45.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#a684f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9878e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#8265c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#634a9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#4e3883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 189.89,
    y1: 7.44,
    x2: 159,
    y2: 10.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#7e61c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4e3883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 191.8,
    y1: 39.68,
    x2: 158.31,
    y2: 47.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab89ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#a382f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#8f71da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6f55af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#4e3883"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 156.65,
    y1: 48.24,
    x2: 153.76,
    y2: 43.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4e3883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#523b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6a50a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7e62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8e70d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9b7bea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a483f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a987fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ab89ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 156.84,
    y1: 19.91,
    x2: 147.14,
    y2: 19.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#4e3883"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#523b88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#6a50a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#7e62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8e70d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#9b7bea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#a483f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#a987fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#ab89ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 22.38,
    y1: 26.2,
    x2: 68.53,
    y2: 26.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#178b91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#158e94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#09b5b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#05c5c5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 73.42,
    y1: 19.9,
    x2: 84.28,
    y2: 19.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5e6b99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#6f63a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#5d6d98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 55.75,
    y1: 1.76,
    x2: 65.18,
    y2: 17.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#576f95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#388ea6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#13b5bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#05c5c5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gradient_new",
    "data-name": "gradient new"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m155.76,20.53c-.92-1.61-2.01-3.14-3.27-4.59h-33.23c3.33,1.24,6.38,3.09,8.31,4.4,1.56,1.06,2.9,2.24,4.01,3.53h25.79c-.45-1.14-.99-2.26-1.62-3.34Zm-22.55,20.68c-.31.53-.65,1.04-1.04,1.54-2.05,2.68-5.01,4.8-8.79,6.3-1.06.42-2.18.84-3.37,1.23h33.1c.99-1.23,1.87-2.51,2.64-3.84.96-1.68,1.73-3.42,2.29-5.23h-24.84Zm0,0c-.31.53-.65,1.04-1.04,1.54-2.05,2.68-5.01,4.8-8.79,6.3-1.06.42-2.18.84-3.37,1.23h33.1c.99-1.23,1.87-2.51,2.64-3.84.96-1.68,1.73-3.42,2.29-5.23h-24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m51.13,66.56h-2.45c-7.25,0-13.96-.85-19.93-2.53-5.97-1.68-11.16-4.06-15.43-7.07-4.26-3-7.59-6.54-9.88-10.53C1.16,42.47,0,38.11,0,33.48s1.16-8.99,3.44-12.95c2.29-3.98,5.61-7.53,9.88-10.53,4.27-3.01,9.47-5.39,15.43-7.07,5.97-1.68,12.68-2.53,19.93-2.53h19.85c-.88.25-1.73.53-2.55.83-4.94,1.83-8.72,4.39-11.24,7.59-1.48,1.88-2.53,3.93-3.15,6.13-.77,0-1.55,0-2.34.01-5.19,0-9.68,1.49-13.39,2.95-3.83,1.51-6.8,3.61-8.84,6.25-2.07,2.67-3.12,5.8-3.12,9.31,0,1.72.26,3.36.78,4.91.52,1.55,1.3,3,2.33,4.35,2.05,2.68,5.02,4.8,8.85,6.3,3.71,1.46,8.2,2.95,13.39,2.95h60.68c1.22,0,2.4-.08,3.53-.22h45.07c3.12,0,5.41-.54,6.99-1.65,1.63-1.15,2.46-2.62,2.46-4.38,0-2.03-.84-3.58-2.5-4.6-1.33-.82-3.13-1.28-5.49-1.4-.25-.01-.5-.02-.76-.03-.19,0-.38,0-.58,0h-76.92c-5.92,0-11.16-.84-15.57-2.5-4.38-1.64-7.8-3.98-10.18-6.94-2.35-2.93-3.55-6.42-3.55-10.38,0-1.19.12-2.34.35-3.45.05-.25.11-.5.18-.75.07-.25.14-.5.21-.75.58-1.86,1.5-3.59,2.76-5.2,2.34-2.99,5.9-5.38,10.58-7.12,2.89-1.07,6.22-1.82,9.95-2.24,2.37-.27,4.91-.4,7.6-.4h75.18c6.54,0,12.28.77,17.06,2.27,4.47,1.41,8.67,3.72,12.49,6.85l-14.42,11.03c-1.39-1.81-3.39-3.21-5.93-4.16-2.78-1.03-6.77-1.56-11.86-1.56h-72.86c-1.5,0-2.78.12-3.87.37-.81.18-1.51.44-2.11.76-.19.1-.37.21-.53.33-.2.14-.38.28-.56.43-1.12.96-1.68,2.16-1.68,3.58,0,3.62,3.14,5.46,9.34,5.46h77.16c5.99,0,11.24.87,15.62,2.59,4.34,1.7,7.77,4.15,10.18,7.26,2.4,3.09,3.61,6.76,3.61,10.9,0,3.9-1.23,7.46-3.67,10.58-2.45,3.14-6.13,5.66-10.93,7.49-4.84,1.84-10.96,2.78-18.18,2.78h-71.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O_shadow",
    "data-name": "O shadow",
    className: "cls-8",
    d: "m90.83,66.97h-3.82l-35.88-.4h-2.45c-7.25,0-13.95-.85-19.93-2.53-5.97-1.68-11.16-4.06-15.43-7.07-4.26-3-7.59-6.54-9.88-10.53-2.28-3.96-3.44-8.32-3.44-12.95s1.16-8.99,3.44-12.95c2.29-3.98,5.61-7.53,9.88-10.53,4.27-3.01,9.47-5.39,15.43-7.07,5.97-1.68,12.68-2.54,19.93-2.54h3.82c-7.25,0-13.95.85-19.93,2.54-5.97,1.68-11.16,4.06-15.43,7.07-4.26,3-7.59,6.54-9.88,10.53-2.28,3.96-3.44,8.32-3.44,12.95s1.16,8.99,3.44,12.95c2.29,3.98,5.61,7.53,9.88,10.53,4.27,3.01,9.47,5.39,15.43,7.07,5.97,1.68,12.68,2.53,19.93,2.53h2.45l35.88.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S_shadow",
    "data-name": "S shadow",
    className: "cls-12",
    d: "m69.98,37.22c4.42,1.66,9.66,2.5,15.57,2.5h-3.82c-5.92,0-11.16-.84-15.57-2.5-4.38-1.64-7.8-3.98-10.18-6.94-2.36-2.93-3.55-6.42-3.55-10.38,0-1.19.12-2.34.35-3.45.05-.25.11-.5.18-.75.06-.24.13-.49.21-.73,0,0,0-.01,0-.02.58-1.85,1.5-3.59,2.76-5.2,2.34-2.99,5.9-5.38,10.58-7.12.04-.02.08-.03.12-.04,2.86-1.05,6.15-1.78,9.83-2.19C78.83.13,81.36,0,84.05,0h3.82c-2.69,0-5.22.13-7.6.4-3.74.42-7.06,1.17-9.95,2.24-4.68,1.74-8.24,4.13-10.58,7.12-1.26,1.61-2.18,3.34-2.76,5.2-.08.25-.15.5-.22.75-.07.25-.12.5-.18.75-.23,1.11-.35,2.26-.35,3.45,0,3.96,1.19,7.45,3.55,10.38,2.38,2.96,5.8,5.29,10.18,6.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Inner_S",
    "data-name": "Inner S",
    className: "cls-5",
    d: "m171.81,45.74c0,1.76-.83,3.23-2.46,4.38-1.58,1.11-3.86,1.65-6.99,1.65h-3.82c3.12,0,5.41-.54,6.99-1.65,1.63-1.15,2.46-2.62,2.46-4.38,0-2.03-.84-3.58-2.5-4.6-1.32-.82-3.13-1.28-5.49-1.4-.25,0-.5-.02-.76-.03-.19,0-.38,0-.58,0h3.82c.2,0,.39,0,.58,0,.26,0,.51.02.76.03,2.36.12,4.17.59,5.49,1.4,1.66,1.02,2.5,2.57,2.5,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m188.78,9.12l-14.42,11.03c-.19-.24-.39-.48-.6-.71l13.49-10.32c-3.82-3.13-8.01-5.44-12.49-6.85C169.99.77,164.24,0,157.7,0h1.53c6.54,0,12.28.76,17.06,2.27,4.47,1.41,8.67,3.72,12.49,6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m190.86,46.12c0,3.9-1.24,7.46-3.67,10.57-2.45,3.14-6.13,5.66-10.93,7.49-4.84,1.84-10.96,2.78-18.18,2.78h-1.53c7.22,0,13.34-.93,18.18-2.78,4.8-1.83,8.48-4.35,10.93-7.49,2.44-3.12,3.67-6.68,3.67-10.57,0-4.14-1.21-7.81-3.62-10.9-2.41-3.11-5.84-5.56-10.18-7.26-4.38-1.72-9.64-2.59-15.62-2.59h1.53c5.99,0,11.24.87,15.62,2.59,4.34,1.7,7.77,4.15,10.18,7.26,2.4,3.09,3.62,6.76,3.62,10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m158.05,41.21c-.56,1.81-1.32,3.55-2.29,5.23-.76,1.33-1.65,2.61-2.64,3.84h-.76c.99-1.23,1.87-2.51,2.64-3.84.96-1.67,1.73-3.42,2.29-5.23h.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m157.38,23.87h-.76c-.46-1.14-1-2.26-1.62-3.34-.92-1.61-2.01-3.14-3.27-4.59h.76c1.25,1.45,2.34,2.99,3.27,4.59.62,1.08,1.16,2.2,1.62,3.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m68.53.4c-.89.25-1.73.53-2.55.83-4.94,1.83-8.72,4.39-11.24,7.6-1.47,1.88-2.53,3.93-3.14,6.13-.77,0-1.55,0-2.34.01-5.19,0-9.68,1.49-13.38,2.95-3.83,1.51-6.8,3.61-8.85,6.25-2.07,2.67-3.12,5.8-3.12,9.31,0,1.72.26,3.36.78,4.91.52,1.55,1.3,3,2.33,4.35,2.05,2.68,5.02,4.8,8.85,6.3,3.71,1.46,8.19,2.95,13.38,2.95h-1.53c-5.19,0-9.68-1.49-13.38-2.95-3.83-1.5-6.8-3.62-8.85-6.3-1.03-1.35-1.81-2.8-2.33-4.35-.52-1.55-.78-3.19-.78-4.91,0-3.51,1.05-6.64,3.12-9.31,2.04-2.64,5.02-4.74,8.85-6.25,3.71-1.46,8.2-2.95,13.38-2.95.79,0,1.57,0,2.34-.01.62-2.2,1.67-4.25,3.14-6.13,2.51-3.21,6.29-5.76,11.24-7.6.82-.3,1.67-.58,2.55-.83h1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m84.28,25.37h-1.53c-6.2,0-9.34-1.84-9.34-5.46,0-1.42.57-2.62,1.68-3.58.17-.15.36-.29.56-.43.17-.11.34-.22.53-.33.6-.32,1.3-.58,2.11-.76,1.09-.24,2.37-.37,3.87-.37h1.53c-1.5,0-2.78.12-3.87.37-.81.18-1.51.44-2.11.76-.19.1-.37.21-.53.33-.2.14-.38.28-.56.43-1.12.96-1.68,2.16-1.68,3.58,0,3.62,3.14,5.46,9.34,5.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.53.4c-.89.25-1.73.53-2.55.83-4.94,1.83-8.72,4.39-11.24,7.6-1.47,1.88-2.53,3.93-3.14,6.13-.55,0-1.11,0-1.67,0,.67-2.08,1.92-4.4,3.28-6.14,2.51-3.21,6.29-5.76,11.24-7.6.82-.3,1.67-.58,2.55-.83h1.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b8e37263fe078a37bdd35dc3c704098f.svg";
export { ForwardRef as ReactComponent };